import React from 'react'
import { Alert } from 'antd'
import { useIntl } from 'react-intl'

import { NUMBER_OF_LOCATIONS_LIMIT, NUMBER_OF_TEAMS_LIMIT } from '@vacationtracker/shared/data/app-parameters'
import IntlMessages from '../../util/IntlMessages'
import { PlanBoostLostFeatures } from './plan-boost-ending-warning-modal'

const DATE_FORMAT = { year: 'numeric', month: 'long', day: 'numeric' } as const
const CORE_LIMITS = { locations: NUMBER_OF_LOCATIONS_LIMIT, departments: NUMBER_OF_TEAMS_LIMIT }

interface IPlanBoostEndingDescriptionProps {
  expiresAt: string
}

export const PlanBoostEndingDescription = ({ expiresAt }: IPlanBoostEndingDescriptionProps): React.ReactElement => {
  const { formatDate } = useIntl()
  const date = formatDate(expiresAt, DATE_FORMAT)

  return (
    <Alert
      type="info"
      showIcon
      message={<IntlMessages id="completeBoost.modal.descriptionEndingSoon" values={{ ...CORE_LIMITS, date }} />}
      description={
        <>
          <PlanBoostLostFeatures />
          <IntlMessages id="completeBoost.modal.cleanupInfo" values={{ date }} />
        </>
      }
    />
  )
}
